import React from 'react';

import {
  Accordion as ChakraAccordion,
  AccordionItem as ChakraAccordionItem,
  AccordionButton as ChakraAccordionButton,
  AccordionPanel as ChakraAccordionPanel,
} from '@chakra-ui/react';
import styled from '@emotion/styled';

import { ArrowRightCircle } from 'assets/assetsV1/iconComponents';

export const Accordion = styled(ChakraAccordion)`
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  overflow: visible;
  background: white;
  width: 100%;
`;

export const AccordionItem = styled(ChakraAccordionItem, {
  shouldForwardProp: (prop) => !['isError'].includes(prop),
})(({ theme, ...props }) => ({
  padding: '0',
  border: 'none',
}));

export const AccordionPanel = styled(ChakraAccordionPanel)`
  margin: 12px;
  margin-top: 0px;
  background: #ebeff3;
  padding: 4px;
  border-radius: 8px;
`;

const StyledAccordionButton = styled(ChakraAccordionButton, {
  shouldForwardProp: (prop) => !['isError'].includes(prop),
})(
  ({ theme, ...props }) => `
  background: white !important;
  min-height: 64px;
  border: 0;
border-radius: 8px;
  padding: 0 24px;
  transform: rotate(0deg);
  svg.toggle-svg {
    transition: transform 100ms;
  }
  &[aria-expanded='true'] {
    svg.toggle-svg {
      transform: rotate(90deg);
    }
  }
  p{
    user-select: text;
  }
`
);

export const AccordionButton = ({ children, ...props }) => (
  <StyledAccordionButton {...props}>
    <ArrowRightCircle className="toggle-svg" mr="8px" fill="transparent" boxSize="16px" color="primary.1565BC" />
    {children}
  </StyledAccordionButton>
);
